import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { PostItem } from 'src/app/types/post';
import { SponsorInterface } from 'src/app/types/sponsor';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss'],
})
export class FeatureComponent implements OnInit {
  sameDay: boolean = false;
  startDate: string | number;
  endDate: string | number;
  updatedAt: string | number;

  @Input() data: PostItem;
  @Input() index: number;
  @Input() type: 'default' | 'competition';
  @Input() showType: boolean;
  @Input() hideCategory: boolean = false;

  desktop: boolean = false;

  constructor(
    private platform: Platform,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.initializeApp();
  }

  /**
   * Link to detail page dependant on content type
   */
  linkToDetail(item) {
    let url;
    let blog: boolean = undefined;

    if (item.postType === 'blog') {
      url = `/blog/${item.slug}`;
    } else if (item.postType === 'event') {
      url = `/event/${item.slug}`;
    } else if (item.postType === 'offer') {
      url = `/offers/${item.slug}`;
    } else if (item.postType === 'competition' && item.typeSettings.isBlog) {
      url = `/blog/${item.slug}`;
      blog = true;
    } else if (item.postType === 'competition') {
      url = `/competition/${item.slug}`;
    }

    this.router.navigate([url], {
      queryParams: { blog },
    });
  }

  /**
   * Check is platform is Desktop on load & resize
   */
  initializeApp() {
    this.platform.ready().then(() => {
      this.desktop =
        this.platform.is('desktop') ||
        (typeof window !== 'undefined' && window.innerWidth > 1200);
    });

    this.platform.resize.subscribe(async () => {
      this.desktop =
        this.platform.is('desktop') ||
        (typeof window !== 'undefined' && window.innerWidth > 1200);
    });
  }

  ngOnInit() {
    if (this.data.updatedAt) {
      this.updatedAt = Date.parse(this.data.updatedAt.replace(/ /g, 'T'));
    }

    if (this.data.postType !== 'blog' && this.data.typeSettings?.startDate && this.data.typeSettings?.endDate) {
      this.startDate = Date.parse(
        this.data.typeSettings.startDate.replace(/ /g, 'T')
      );
      this.endDate = Date.parse(
        this.data.typeSettings.endDate.replace(/ /g, 'T')
      );
    }

    if (
      this.startDate &&
      this.endDate &&
      this.datePipe.transform(this.startDate, 'yyyy-MM-dd') ===
        this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
    ) {
      this.sameDay = true;
    }

    if (this.index > 0) this.data.alignment = 'left';
  }
}
